<template>
  <div class="image-editor">
    <!-- 标题 -->
    <h1 class="editor-header">
      图片叠加层编辑
    </h1>

    <!-- 工具栏 -->
    <div class="toolbar">
      <span>图片信息：</span> {{ `zoom：${this.zoom} coord：${this.maxX}-${this.maxY}-${this.minX}-${this.minY}` }}
      <span>叠加层:</span>
      <el-select v-model="gridType" placeholder="网格类型" style="width: 150px;">
        <el-option label="不叠加" value="none"></el-option>
        <el-option label="高斯网格-六度" value="gaussian"></el-option>
        <!-- <el-option label="经纬度网格" value="latitudeLongitude"></el-option> -->
      </el-select>
      <span v-if="gridType !== 'none'">网格显示:</span>
      <el-color-picker v-if="gridType !== 'none'" v-model="gridColor" show-alpha
        style="margin-left: 10px;"></el-color-picker>
      <span v-if="gridType !== 'none'">网格粗细:</span>
      <el-input v-if="gridType !== 'none'" v-model.number="gridLineWidth" type="number" placeholder="网格粗细"
        style="width: 100px; margin-left: 10px;" :min="1"></el-input>
      <span v-if="gridType !== 'none'">添加坐标值:</span>
      <el-switch v-if="gridType !== 'none'" v-model="addTextEnabled" active-text="是" inactive-text="否"
        style="margin-left: 10px;"></el-switch>
      <el-button @click="saveImage" style="margin-left: 10px;" icon="el-icon-download">保存图片</el-button>
    </div>

    <!-- 图片容器 -->
    <div class="image-container" ref="imageContainer">
      <canvas ref="canvas"></canvas>
      <!-- <div class="zoom-controls">
        <el-button type="primary" icon="el-icon-zoom-in" @click="zoomIn"></el-button>
        <el-button type="primary" icon="el-icon-zoom-out" @click="zoomOut"></el-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { baseURL } from '@/util/http'
import { drawGaussGrid } from '@/util/grid'
import formatter from '@/util/geoUtil'

export default {
  data() {
    return {
      imagePadding: 30,
      imageFileName: this.$route.query.imageFileName,
      maxX: parseInt(this.$route.query.maxX) || 0,
      maxY: parseInt(this.$route.query.maxY) || 0,
      minX: parseInt(this.$route.query.minX) || 0,
      minY: parseInt(this.$route.query.minY) || 0,
      zoom: parseInt(this.$route.query.zoom) || 1,
      gridType: 'none', // 网格类型：none（不叠加）、gaussian（高斯网格）、latitudeLongitude（经纬度网格）
      gridColor: '#000000', // 网格颜色
      gridLineWidth: 1, // 网格线条粗细
      canvas: null, // canvas 对象
      ctx: null, // canvas 上下文
      img: null, // 图片对象
      scale: 1, // 缩放比例
      loading: false, // 加载状态
      addTextEnabled: true // 是否添加文字

    };
  },
  computed: {
    imageUrl() {
      return `${baseURL}/user/down?name=${this.imageFileName}`
    }
  },
  methods: {
    // 初始化 canvas 并加载图片
    initCanvas() {
      this.canvas = this.$refs.canvas;
      this.ctx = this.canvas.getContext('2d');

      // 显示loading对话框
      const loadingInstance = this.$loading({
        lock: true,
        text: '图片加载中,请稍等（视网速不同，时间等待有差异）...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 加载图片
      this.img = new Image();
      this.img.crossOrigin = 'anonymous'; // 支持跨域图片
      this.img.src = this.imageUrl;

      // 图片加载完成后绘制图片和文字
      this.img.onload = () => {
        loadingInstance.close();
        this.drawImage();
      };

      // 图片加载失败处理
      this.img.onerror = () => {
        loadingInstance.close();
        this.$message.error('图片加载失败');
      };
    },
    // 绘制图片和网格
    drawImage() {
      if (!this.ctx || !this.img) return;
      // 设置 canvas 尺寸为图片原始尺寸
      this.canvas.width = this.img.width + this.imagePadding * 2
      this.canvas.height = this.img.height + this.imagePadding * 2
      // 清空画布并填充白色背景
      this.ctx.fillStyle = 'white'
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)
      // 在画布上绘制图片，并留出20px的留白
      this.ctx.drawImage(this.img, this.imagePadding, this.imagePadding, this.img.width, this.img.height);
      // 绘制网格
      this.drawGrid();
    },
    // 绘制网格
    drawGrid() {
      if (this.gridType === 'none') return;

      this.ctx.strokeStyle = this.gridColor;
      this.ctx.lineWidth = this.gridLineWidth;

      if (this.gridType === 'gaussian') {
        this.drawGaussianGrid();
      } else if (this.gridType === 'latitudeLongitude') {
        this.drawLatitudeLongitudeGrid();
      }
    },
    // 绘制高斯网格
    drawGaussianGrid() {
      drawGaussGrid(this.ctx,
        this.img.width,
        this.img.height,
        this.imagePadding,
        this.minX,
        this.minY,
        this.maxX,
        this.maxY,
        this.zoom,
        this.addTextEnabled)
    },
    // 绘制经纬度网格
    drawLatitudeLongitudeGrid() {
      const latStep = this.canvas.height / 10; // 纬度线间距
      const lonStep = this.canvas.width / 10; // 经度线间距

      // 绘制纬度线
      for (let y = 0; y <= this.canvas.height; y += latStep) {
        this.ctx.beginPath();
        this.ctx.moveTo(0, y);
        this.ctx.lineTo(this.canvas.width, y);
        this.ctx.stroke();
      }

      // 绘制经度线
      for (let x = 0; x <= this.canvas.width; x += lonStep) {
        this.ctx.beginPath();
        this.ctx.moveTo(x, 0);
        this.ctx.lineTo(x, this.canvas.height);
        this.ctx.stroke();
      }
    },
    // 保存图片
    saveImage() {
      if (!this.canvas) return;
      // 显示loading对话框
      const loadingInstance = this.$loading({
        lock: true,
        text: '处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const quality = 0.5
      // 将 canvas 转换为图片并下载
      this.canvas.toBlob((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob); // 创建一个Blob URL
        link.download = "canvas.png"; // 设置下载的文件名
        link.click(); // 触发下载
        loadingInstance.close()
      }, "image/png", quality);
    },
    // 放大
    zoomIn() {
      this.zoomf(1.1);
    },
    // 缩小
    zoomOut() {
      this.zoomf(0.9);
    },
    // 缩放核心方法
    zoomf(delta) {
      this.scale *= delta;
      // 限制缩放范围 0.5-3
      this.scale = Math.min(Math.max(0.5, this.scale), 3);
      // 应用缩放
      this.ctx.setTransform(1, 0, 0, 1, 0, 0); // 重置变换
      this.ctx.scale(this.scale, this.scale);
      this.drawImage();
    }
  },
  watch: {
    // 监听网格类型、网格颜色、网格粗细的变化，重新绘制
    gridType() {
      this.drawImage()
    },
    gridColor() {
      this.drawImage()
    },
    gridLineWidth() {
      this.drawImage()
    },
    addTextEnabled() {
      this.drawImage()
    }
  },
  mounted() {
    this.initCanvas()
  }
};
</script>

<style scoped>
.image-editor {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /* 占满整个视口高度 */
  padding: 10px;
  box-sizing: border-box;
}

.toolbar {
  flex-shrink: 0;
  /* 工具栏固定高度 */
  margin: 0 0 20px 20px;
  /* 上 右 下 左 */
  display: flex;
  align-items: center;
  /* 垂直居中 */
  gap: 10px;
  /* 元素间距 */
  font-size: 14px;
}

.image-container {
  flex-grow: 1;
  /* 图片容器占满剩余空间 */
  overflow: auto;
  /* 支持滚动 */
  border: 1px solid #ccc;
  padding: 10px;
}

canvas {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Edit.vue